import './ProgramPage.css'

import React from 'react'
import { withProps } from 'recompose'

import { getTracks } from '../app/selectors'
import ScheduleTable from './ScheduleTable'
import content from '../content'

const ProgramPage = ({ tracks }) => {
  return (
    <div>
      <ScheduleTable tracks={tracks} />
    </div>
  )
}

const tracks = getTracks(content)

const withPageContent = withProps({
  tracks,
})

export default withPageContent(ProgramPage)



// WEBPACK FOOTER //
// ./src/containers/ProgramPage.js